import { authHeader } from "@roman/shared/lib/auth/authHeader";
import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { ReportReason } from "@roman/shared/types/Comment";
import useSWRMutation, { type SWRMutationConfiguration } from "swr/mutation";

type ReportCommentInput = {
  predictionMarketId: string;
  commentId: string;
  reason: ReportReason;
};

const fetcher = async (
  _url: string,
  { arg: { predictionMarketId, commentId, reason } }: { arg: ReportCommentInput },
): Promise<void> => {
  const headers = authHeader.getOrThrow();
  await romanApi.post<void, { reason: ReportReason }>(
    `/prediction-market/${predictionMarketId}/comments/${commentId}/report`,
    { reason },
    { headers },
  );
};

export const useReportComment = (
  swrOptions?: SWRMutationConfiguration<void, RomanApiError, string, ReportCommentInput, void>,
) => {
  const { trigger, isMutating, error, data } = useSWRMutation(
    "/prediction-market/comments/report",
    fetcher,
    swrOptions,
  );

  return {
    reportComment: trigger,
    isMutating,
    error,
    data,
  };
};
